import { Vector3, type Camera } from 'three';

export const POI_EDGE_HIT_RADIUS_PX = 8;
export const SNAP_CAPTURE_RADIUS_PX = 12;
// Connector/anchor manual snapping: magnetic radius for snap ranges; snap points get SNAP_POINT_CAPTURE_FACTOR on top
export const CONNECTOR_SNAP_CAPTURE_RADIUS_PX = 24;
export const SNAP_POINT_CAPTURE_FACTOR = 2;
export const SNAP_RELEASE_FACTOR = 1.75;
export const SNAP_SWITCH_FACTOR = 0.75;
export const SNAP_MARKER_RADIUS_PX = 7;
export const SNAP_PREVIEW_DISTANCE_FACTOR = 2.5;
export const SNAP_FALLBACK_DISTANCE = 0.1;
export const INTERACTION_RENDER_ORDER = 10001;
export const INTERACTION_LINE_WIDTH_PX = 4;
export const INTERACTION_HALO_WIDTH_PX = 8;

const cameraPoint = new Vector3();

export function getWorldUnitsPerPixel(camera: Camera, point: Vector3, viewportHeight: number): number {
    cameraPoint.copy(point).applyMatrix4(camera.matrixWorldInverse);
    const depth = camera.projectionMatrix.elements[15] === 0 ? Math.abs(cameraPoint.z) : 1;
    return (2 * depth) / (Math.abs(camera.projectionMatrix.elements[5]) * Math.max(viewportHeight, 1));
}

export function getSnapCaptureDistance(
    camera: Camera | undefined,
    viewportHeight: number,
    point: Vector3,
    fallbackDistance = SNAP_FALLBACK_DISTANCE,
    radiusPx = SNAP_CAPTURE_RADIUS_PX
): number {
    return camera && viewportHeight > 0
        ? radiusPx * getWorldUnitsPerPixel(camera, point, viewportHeight)
        : fallbackDistance;
}
